import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setSearchPerfDateOverridden } from 'src/context/reducers/filter-settings/filterSlice';

export default function SearchPerformanceLayout() {
  const dispatch = useDispatch();

  // Reset on UNMOUNT (section exit), not on mount: React runs child effects before
  // parent effects, so a mount-reset would be read too late by the page components.
  // Resetting on unmount guarantees the flag is false on the next section entry.
  useEffect(() => () => { dispatch(setSearchPerfDateOverridden(false)); }, [dispatch]);

  return <Outlet />;
}
